import React from "react";
import { connect } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { logout } from '../api/Login';

import * as actions from '../actions';
class AlertExpire extends React.Component {
    async clearData()  {
        let res = await logout();
        this.props.history.push({ pathname: '/' })
        // const initialState = { key: '', name: '', userId: '', isAuth: false }
        this.props.keepUser(res.data);   
    }
    render() {
        const WhatExpired = this.props.SessionLogout;
        if (WhatExpired) {
            return (
                <Modal isOpen={true}>
                    <ModalHeader>Session Expired</ModalHeader>
                    <ModalBody>
                        <p>
                            The session has expired due to setting the account password.
                        </p>
                    </ModalBody>
                    <ModalFooter><Button onClick={() => this.clearData()}>Ok</Button></ModalFooter>
                </Modal>
            )
        }
        return (
            <Modal isOpen={true}>
                <ModalHeader>Session Expired</ModalHeader>
                <ModalBody>
                    <p>
                        Session has been expired.
                        Login and try again.
                    </p>
                </ModalBody>
                <ModalFooter><Button onClick={() => this.clearData()}>Ok</Button></ModalFooter>
            </Modal>
        )
    }
}
function mapStateToProps(state) {
    return { auth: state.auth };
}
export default connect(mapStateToProps, actions)(AlertExpire);